import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { useEffect } from "react";
import { auth } from "../firebase";
import { syncRestaurantListener } from "../features/restaurant/restaurant.listener";
import { syncWalletListener } from "../features/wallet/wallet.listener";
import { syncSessionListeners } from "../features/session/session.listener";
import { syncBillListener } from "../features/bill/bill.listener";
import { syncMenuListener } from "../features/menu/menu.listener";
import { syncMenuItemListener } from "../features/menuItem/menuItem.listener";
import { syncAvailabilityListener } from "../features/availability/availability.listener";
import { syncApprovementListener } from "../features/approvement/approvement.listener";

export const useCentralizedListeners = () => {
  const dispatch = useDispatch();

  const uid = useSelector(() => auth.currentUser?.uid ?? null);
  const authLogged = useSelector((state: RootState) => state.auth.logged);
  const restaurantId = useSelector((state: RootState) => state.restaurant.restaurantId);
  const restaurant = useSelector((state: RootState) => state.restaurant.restaurant);
  const sessionId = useSelector((state: RootState) => state.session.sessionId);
  const menuId = useSelector((state: RootState) => state.menu.menuId);
  const menu = useSelector((state: RootState) => state.menu.menu);
  const menuItemPath = useSelector((state: RootState) => state.menuItem.menuItemPath);
  const approvementId = useSelector((state: RootState) => state.approvementRequest.approvementId);

  useEffect(() => {
    if (!authLogged) return;
    syncRestaurantListener(restaurantId ?? null, dispatch);
    return () => { syncRestaurantListener(null, dispatch); };
  }, [restaurantId, authLogged, dispatch]);

  useEffect(() => {
    syncWalletListener(uid, restaurantId ?? null, dispatch);
    return () => { syncWalletListener(null, null, dispatch); };
  }, [uid, restaurantId, dispatch]);

  useEffect(() => {
    syncSessionListeners(restaurantId ?? null, sessionId ?? null, dispatch);
    return () => { syncSessionListeners(null, null, dispatch); };
  }, [restaurantId, sessionId, dispatch]);

  useEffect(() => {
    syncBillListener(restaurantId ?? null, sessionId ?? null, dispatch);
    return () => { syncBillListener(null, null, dispatch); };
  }, [restaurantId, sessionId, dispatch]);

  useEffect(() => {
    syncMenuListener(restaurantId ?? null, menuId ?? null, dispatch);
    return () => { syncMenuListener(null, null, dispatch); };
  }, [restaurantId, menuId, dispatch]);

  useEffect(() => {
    syncMenuItemListener(menuItemPath ?? null, dispatch);
    return () => { syncMenuItemListener(null, dispatch); };
  }, [menuItemPath, dispatch]);

  useEffect(() => {
    syncAvailabilityListener(restaurant ?? null, menu ?? null, dispatch);
    return () => { syncAvailabilityListener(null, null, dispatch); };
  }, [restaurant, menu, dispatch]);

  useEffect(() => {
    syncApprovementListener(restaurantId ?? null, sessionId ?? null, approvementId ?? null, dispatch);
    return () => { syncApprovementListener(null, null, null, dispatch); };
  }, [restaurantId, sessionId, approvementId, dispatch]);
};